import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { AdvancedFilter } from '@kodit/core/shared-ui';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { Store } from '@ngrx/store';
import {
  clearFilter,
  setFilter,
} from '../../../../../../../shared-subforms/src/lib/racun/state/filters/filter.actions';
import { StrankaMultiSelectItem } from '@kodit/core/data-api';

export interface IPrimljenoObavestenjeFilter {
  dateFrom?: Date;
  dateTo?: Date;
  searchTerm?: string;
  stranke?: StrankaMultiSelectItem[];
}

@Component({
  selector: 'kodit-primljeno-obavestenje-filter',
  templateUrl: './primljeno-obavestenje-filter.component.html',
  styleUrls: ['./primljeno-obavestenje-filter.component.scss'],
})
export class PrimljenoObavestenjeFilterComponent
  implements OnInit, AdvancedFilter<IPrimljenoObavestenjeFilter>
{
  filterData!: IPrimljenoObavestenjeFilter;
  form!: FormGroupTypeSafe<IPrimljenoObavestenjeFilter>;

  @Output() onSubmitForm = new EventEmitter<IPrimljenoObavestenjeFilter>();

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _storage: Store
  ) {}

  ngOnInit(): void {
    this.form = this._buildForm(this.filterData);
  }

  onFilterSubmit() {
    this._storage.dispatch(
      setFilter({
        key: 'SEF|Primljeno',
        filter: JSON.stringify(this.form.value),
      })
    );
  }

  onFilterHide(shouldReset: boolean) {
    if (shouldReset) {
      this._storage.dispatch(clearFilter({ key: 'SEF|Primljeno' }));
    }
  }

  get strankeFormArray(): FormArray {
    return this.form.get('stranke') as FormArray;
  }

  private _buildForm(
    model: IPrimljenoObavestenjeFilter
  ): FormGroupTypeSafe<IPrimljenoObavestenjeFilter> {
    return this._fb.group<IPrimljenoObavestenjeFilter>({
      dateFrom: new FormControl(model?.dateFrom ? new Date(model.dateFrom) : null),
      dateTo: new FormControl(model?.dateTo ? new Date(model.dateTo) : null),
      searchTerm: new FormControl(model?.searchTerm ?? null),
      stranke: new FormArray(model?.stranke?.map((s) => new FormControl(s)) ?? []),
    });
  }
}
